import { CategoryIcon } from '@/components/CategoryIcon';
import { type CategoryMeta, categoryChipStyleFromMeta } from '@/components/transactions/screen/categoryIndex';
import { cn } from '@/lib/utils';

const TILE = {
  /** Compact lists (a fatura's items, drawers' nested rows). */
  sm: { box: 'size-9 rounded-xl', icon: 'size-4' },
  /** The transaction line. */
  md: { box: 'size-11 rounded-2xl', icon: 'size-5.5' },
  /** A detail drawer's hero. */
  lg: { box: 'size-12 rounded-2xl', icon: 'size-6' },
} as const;

/** A category's icon on its tinted square — the leading mark of every transaction line and detail hero. */
export function CategoryTile({ meta, size = 'md', className }: Readonly<{
  meta: CategoryMeta;
  size?: keyof typeof TILE;
  className?: string;
}>) {
  const style = categoryChipStyleFromMeta(meta);
  const tile = TILE[size];
  return (
    <span
      className={cn('flex shrink-0 items-center justify-center', tile.box, className)}
      style={{ backgroundColor: style.backgroundColor }}
    >
      <CategoryIcon name={meta.iconName} className={tile.icon} style={{ color: style.color }} />
    </span>
  );
}
